// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:33:29.996Z
// Property: Newell Village (ID: 6767906449167641)
// Collections: 10 amenities, 2 floorplans (live), 17 photos, 42 POIs, 5 reviews, 2 virtual tours, 5 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167641",
  "property_external_id": "1702697",
  "property_zillow_url": "https://www.zillow.com/apartments/charlotte-nc/newell-village/CgHFSn/",
  "property_apartments_url": "https://www.apartments.com/newell-charlotte-nc/lofts/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57148496392",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "newell-village",
  "property_name": "Newell Village",
  "property_website_url": "https://www.newellvillage.com",
  "property_domain": "https://www.newellvillage.com",
  "property_address": "2341 Jons Creek Ln",
  "property_full_address": "2341 Jons Creek Ln, Charlotte, NC 28213",
  "property_address_1": "2341 Jons Creek Ln",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28214",
  "property_address_zip": "28213",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Newell South",
  "property_address_latitude": "35.281635",
  "property_address_longitude": "-80.747197",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(828) 840-7587",
  "property_call_tracking_phone": "828-840-7587",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Brand-new three-bedroom townhome rentals in Newell South.</strong> Newell Village pairs extra space and smart-home comfort with professionally managed ease, lawn care included, and pet-friendly details that make everyday living simple.</p>",
  "property_long_description": "<p><strong>Brand-new townhome living in Newell South.</strong> At Newell Village, you get the space and privacy of a three-bedroom townhome with the ease of a professionally managed rental community. Choose from the Kent or Katana <a href=\"/floor-plans\">floor plans</a>, each designed with everyday comfort in mind: stainless steel appliances, granite countertops, luxury flooring, spacious closets, in-unit laundry, and smart-home features like connected access and climate controls.</p><p>Outside your door, lawn maintenance is handled for you, with a playground, pet waste stations, and a pet-friendly setting that keeps daily routines simple. Explore more <a href=\"/amenities\">community and home features</a>, then picture life close to University City, UNC Charlotte, the LYNX Blue Line, and everyday shopping and dining along University City Boulevard. Reedy Creek Park and Nature Center, the UNC Charlotte Botanical Gardens, NoDa, and Uptown Charlotte are all within easy reach, giving you a connected Charlotte address with room to settle in.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with bar stools.",
    "public_id": "01a15ec5-8f89-7658-801a-48b46c674c96",
    "storage_key": "property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167641/01a0c019-0e0a-7548-a59c-a288c9253572.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c019-0e0a-7548-a59c-a288c9253572",
    "storage_key": "property/6767906449167641/01a0c019-0e0a-7548-a59c-a288c9253572.mp4",
    "thumbnail_key": "property/6767906449167641/01a0c019-0e0a-7548-a59c-a288c9253572_thumb.webp",
    "size_bytes": 18155194,
    "classification": "Community",
    "title": "Explore Our Beautiful Townhome Community",
    "description": "Discover our vibrant townhome community featuring modern exteriors, green spaces, and family-friendly amenities like a playground."
  },
  "property_total_units": "120",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "13",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge fee $10.95, landscaping $45 (townhome), smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Dangerous or poisonous animals and exotic pets are not permitted.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets (written approval needed for more). One-time non-refundable pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit per pet and breed restrictions apply; pet screening is required before move-in. Fish allowed with no fee or rent (tanks up to 20 gallons).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://newellvillage.securecafe.com/onlineleasing/newell-village-clark-village/floorplans.aspx",
  "property_resident_portal_url": "https://newellvillage.securecafenet.com/residentservices/newell-village-clark-village/userlogin",
  "property_apply_now_url": "https://newellvillage.securecafe.com/onlineleasing/newell-village-clark-village/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#21834c",
  "property_secondary_color": "#95b4c5",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1467 - 1584",
  "property_sqft_min": "1467",
  "property_sqft_max": "1584",
  "property_price_range": "1899 - 2686",
  "property_price_min": "1907",
  "property_price_max": "2686",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61552006362028",
  "property_instagram_url": "https://www.instagram.com/newellvillage/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJi0PR-BYfVIgRH-6RCVks-nA",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Newell Village",
  "property_home_romance_title": "Experience the Joy of Living at Our Charming Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, built in.</strong> Newell Village pairs polished granite, stainless steel appliances, luxury flooring, and smart-home controls for access, climate, lighting, and leak detection. In-unit laundry and spacious closets keep routines streamlined, while professional lawn maintenance and pet waste stations help the community feel clean, current, and low-effort.</p>",
  "property_home_floorplans_blurb": "<p><strong>Three-bedroom townhome space with polished everyday finishes.</strong> Explore the Kent and Katana layouts at Newell Village, each offering open living areas, multi-level comfort, generous storage, and roomy closets. Granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and smart-home features bring a refined edge to townhome living in Newell South.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at Newell Village.</strong> Explore photos of townhome interiors with granite countertops, stainless steel appliances, clean-lined cabinetry, luxury flooring, generous closet storage, and in-unit laundry. Outside, see fresh curb appeal, maintained green space, pet-friendly conveniences, and a playground woven into the community setting.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Connected calm in Newell South.</strong> Newell Village places daily errands, dining, and shopping within easy reach along University City Boulevard and North Tryon, with lakeside meals at The Boardwalk nearby. Trails and garden paths at Reedy Creek Nature Center and UNC Charlotte Botanical Gardens add fresh-air escapes, while the LYNX Blue Line at University City Boulevard connects you to NoDa, Uptown, and South End.</p>",
  "property_home_reviews_blurb": "<p><strong>Service residents remember.</strong> Newell Village reviews spotlight an easy move-in, clear communication, and follow-through that continues after move-in day. Residents mention James for a seamless leasing process, Lisa for thoughtful check-ins, and Anthony for fast, friendly maintenance. Read the full reviews to see how everyday support shapes the experience here.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then make it your routine.</strong> From Newell Village, Newell South puts you close to the everyday energy of University City while keeping a residential feel. Follow University City Boulevard or North Tryon for shopping, errands, and local dining, or head to The Boardwalk at The Shoppes at University Place for lakeside meals and a casual night out. When you want more room to roam, Reedy Creek Nature Center and the UNC Charlotte Botanical Gardens bring trails, gardens, and fresh-air pauses nearby. The LYNX Blue Line at University City Boulevard also keeps Charlotte connected, with a straightforward route toward NoDa, Uptown, and South End. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this location fits your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Let the details do more of the daily work.</strong> At Newell Village, amenities are built around comfort you can feel every day—from polished granite surfaces and stainless steel appliances to luxury flooring that keeps your townhome feeling clean and current. Smart-home features add modern control with connected access, climate settings, lighting, and leak-sensing technology, while in-unit laundry and spacious closets help your routines stay organized.</p><p>Outside, professionally handled lawn maintenance keeps curb appeal off your chore list, and pet waste stations add convenience to the community setting. Browse the <a href=\"/gallery\">photo gallery</a> to see the finishes up close, then compare available <a href=\"/floor-plans\">three-bedroom layouts</a> and find the townhome that fits the way you want to live.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for Newell Village.</strong><br>Brand-new three-bedroom townhomes offer the space, comfort, and professionally managed ease you’ve been looking for, with modern finishes, in-unit laundry, smart-home features, and lawn maintenance handled for you. Apply online today and take the next step toward calling Newell Village home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Newell Village leasing team to learn more about brand-new three-bedroom townhome living in Newell South, professionally managed rental convenience, and available Kent and Katana floor plans. We’re here to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Newell Village?</strong> Start here for quick answers about brand-new three-bedroom townhome living, leasing, community features, and everyday details. If you need anything else, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Compare two spacious three-bedroom townhome layouts made for real everyday living.</strong> At Newell Village, the Kent and Katana floor plans give you room to spread out with open living areas, generous storage, and the comfort of a multi-level home. As you review current pricing and availability, look for the details that make each layout feel polished from the start: granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, smart-home features, and roomy closets.</p><p>Choose the streamlined feel of the Kent or the added roominess of the Katana, both set in Newell South with the ease of professionally managed townhome living. Explore more <a href=\"/amenities\">in-home finishes</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Newell Village in focus.</strong> Browse the gallery for a closer look at bright, townhome interiors where granite countertops, stainless steel appliances, and clean-lined cabinetry frame the kitchen scenes. Follow the photos into open living areas with luxury flooring underfoot, then notice the practical details tucked into everyday spaces, from generous closet storage to in-unit laundry.</p><p>Outside, the images capture the ease of a polished Newell South setting: fresh curb appeal, maintained green space, pet-friendly conveniences, and a playground area designed into the community layout. As you explore each view, picture how the finishes, flow, and outdoor spaces come together—then continue with the <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Newell Village beyond the frame.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Newell Village on the map.</strong> See available three-bedroom townhomes in Newell South, then zoom out to picture your day-to-day around nearby shopping, dining, transit, parks, and Charlotte destinations—all from a connected address with room to settle in.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, leashes, and easy routines.</strong><br>At Newell Village, pet-friendly townhome living feels practical from the first morning walk. Cats and dogs are welcome, with multi-level three-bedroom layouts that give everyone space to spread out, plus in-unit laundry for muddy towels, well-sized closets for gear, and lawn care handled outside.</p><p>Community pet waste stations help keep quick walks simple, while the Newell South setting places everyday pet errands and fresh-air time within reach. For a longer outing, Reedy Creek’s dog park and wooded trails are close by; back at home, smart-home features add everyday ease after the leash comes off. Explore <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Newell Village fits life with your pet.</p>",
  "property_referafriend_blurb": "<p><strong>Share brand-new townhome living.</strong> If you love the space and privacy of a three-bedroom townhome with the ease of professional management, invite a friend to discover Newell Village. Send a referral and let them picture everyday comfort, smart-home features, and simple routines in Newell South.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Newell Village.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with the same everyday ease that defines this professionally managed townhome community.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from residents, grounded in everyday service.</strong> Reviews for Newell Village consistently highlight a smooth move-in experience, clear communication, and a team that stays attentive after the keys are handed over.</p><p>You’ll see residents calling out James for keeping the process “easy and seamless,” Lisa for checking in and offering help, and Anthony for prompt, personable maintenance support. From quick fixes to ongoing community care, the reviews point to a professionally managed experience where questions are answered, requests are handled, and residents feel supported throughout their time at Newell Village.</p>",
  "property_created_at": "1786373961629",
  "property_scheduletour_blurb": "<p><strong>See brand-new townhome living up close.</strong> Tour Newell Village and experience the space of a three-bedroom rental townhome, professionally managed ease, and polished everyday finishes like granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and smart-home features. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>The Newell Village leasing team will be in touch soon. In the meantime, picture brand-new three-bedroom townhome living with smart-home features, in-unit laundry, handled lawn maintenance, and the ease of a professionally managed rental community in Newell South.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> The Kent and Katana virtual tours let you move through each three-bedroom townhome layout at your own pace, so you can see how the main living areas, kitchen, bedrooms, storage, and everyday details connect in real time. Pause on the finishes that matter most—granite countertops, stainless steel appliances, luxury flooring, and smart-home touches—then keep exploring to get a better feel for the home’s flow.</p><p>Use the tour to narrow your questions, compare it with current <a href=\"/floor-plans\">floor plan availability</a>, and decide what you want to see next in person. When you’re ready, <a href=\"/schedule-a-tour\">schedule a tour</a> and experience Newell Village beyond the screen.</p>",
  "property_copyright": "2026 All Rights Reserved. Newell Village",
  "property_seo_title_home": "Newell Village |  Apartments in Charlotte, NC",
  "property_seo_description_home": "Explore Newell Village in Charlotte, NC—modern 3-bedroom homes with luxury finishes, smart tech, and excellent amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Charlotte, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Newell Village in Charlotte, NC! Browse spacious three-bedroom floor plans tailored for modern living. Your dream home awaits!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at Newell Village, Charlotte, NC! Spacious floor plans, premium amenities, and smart-home tech await your perfect home!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Elevate your lifestyle at Newell Village in Charlotte, NC! Picture spacious apartments with stainless steel appliances, luxury flooring, and modern amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Newell Village Apartments",
  "property_seo_description_virtualtours": "Step inside Newell Village in Charlotte, NC! Take our virtual tour to explore spacious 3-bedroom floor plans and see your new community come to life.",
  "property_seo_title_interactivemap": "Interactive Map | Newell Village Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Newell Village, Charlotte! Enjoy luxury living with spacious layouts, smart tech, and a vibrant community. Explore now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Experience Charlotte living at Newell Village! Discover vibrant local favorites and hidden gems just steps from your new home. Explore your neighborhood today!",
  "property_seo_title_contact": "Contact Us | Newell Village",
  "property_seo_description_contact": "Experience the charm of Newell Village in Charlotte, NC! Browse our spacious three-bedroom floor plans and connect with our leasing team for any inquiries!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "At Newell Village in Charlotte, NC, find answers to your burning questions! Learn about our luxury amenities, floor plans, and pet-friendly features. Join us!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover Newell Village in Charlotte, NC! Explore resident reviews showcasing our spacious layouts, luxury amenities, and smart-home tech.",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Find your perfect home at Newell Village in Charlotte, NC! Enjoy luxury finishes, spacious layouts, and family-friendly amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Newell Village",
  "property_seo_description_residentaccess": "Experience convenience at Newell Village! Access the resident portal for rent payments, maintenance requests, and community updates—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Newell Village",
  "property_seo_description_referafriend": "Refer a friend to Newell Village in Charlotte, NC! Great friends create great neighbors—share the love of your community today and enjoy exclusive perks!",
  "property_seo_title_scheduletour": "Schedule a Tour | Newell Village",
  "property_seo_description_scheduletour": "Step into modern elegance at Newell Village in Charlotte, NC. Schedule a tour today and envision your vibrant life in our welcoming apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Newell Village",
  "property_seo_description_privacy": "Your privacy matters at Newell Village, Charlotte, NC. Discover how we safeguard your information for a secure living experience. Read our policy.",
  "property_seo_title_accessibility": "Website Accessibility | Newell Village",
  "property_seo_description_accessibility": "At Newell Village in Charlotte, NC, we prioritize digital inclusion, ensuring all residents can access resources easily and effectively.",
  "property_seo_title_sitemap": "Sitemap | Newell Village",
  "property_seo_description_sitemap": "Navigate through Newell Village's sitemap to uncover a community where comfort meets convenience in the heart of Charlotte, NC. Your new home awaits!",
  "property_seo_title_thankyou": "Thank You | Newell Village",
  "property_seo_description_thankyou": "Thanks for contacting Newell Village in Charlotte, NC! Our team will be in touch soon. Get ready for amazing apartment living!",
  "property_seo_title_pets": "Pet Policy | Apartments in Charlotte, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793288686537",
  "amenities": [
    {
      "id": "ec_0d724d803f696b1ac8ced983",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116560",
      "title": "Future Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e9525a74f9489f0053de603",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116564",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f3942608d4f4b770786d93f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116567",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_211bfe3d85d9fe2b61f09912",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116561",
      "title": "Pet Waste Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c97ea8f2f98a9990388131d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116562",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01de350cd2050afe83fa69ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116569",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2092f68a15ff456b548dd683",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116563",
      "title": "Security Deposit Alternative",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e955b90d404a737f8f288cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116570",
      "title": "Spacious Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1da77300aeba7f5888b428f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116571",
      "title": "Smart Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b76529b008dc4ac057c524b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "123116572",
      "title": "In-Unit Laundry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_01c76402e7c19ae55db439d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a15ec5-8f89-7658-801a-48b46c674c96",
        "storage_key": "property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek gray cabinetry, elegant granite countertops, and a convenient island perfect for casual dining.",
      "link": "false",
      "alt_text": "A kitchen with a countertop and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/18-web-or-mls-Jons%20Crk%20Ln-S1710-012%20virtually%20staged.jpg"
    },
    {
      "id": "ec_eb9d2d9b4535645a98f45fa5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-0b0c-70b8-aaf5-d019423c3697.webp",
      "image_media": {
        "alt_text": "Exterior of townhomes with garages and green lawn.",
        "public_id": "01a183b0-0b0c-70b8-aaf5-d019423c3697",
        "storage_key": "property/6767906449167641/01a183b0-0b0c-70b8-aaf5-d019423c3697.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern townhomes with attached garages and manicured front yards offer a welcoming street view.",
      "link": "false",
      "alt_text": "A house with a white garage door and a tree in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/58-web-or-mls-Jons%20Crk%20Ln-S1710-038.jpg"
    },
    {
      "id": "ec_d22c4fff22a8b79fe7f40777",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-9032-705d-820f-7285eaeb112b.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with modern finishes and a large sectional sofa.",
        "public_id": "01a15ec5-9032-705d-820f-7285eaeb112b",
        "storage_key": "property/6767906449167641/01a15ec5-9032-705d-820f-7285eaeb112b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space, perfect for entertaining or relaxing. This area seamlessly connects the living room to a modern, fully-equipped kitchen.",
      "link": "false",
      "alt_text": "A living room with a beige couch and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/13-web-or-mls-Jons%20Crk%20Ln-S1710-009%20virtually%20staged.jpg"
    },
    {
      "id": "ec_66520eff217dabf867c2d805",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-0e41-7171-aea8-089b52784287.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light gray cabinets.",
        "public_id": "01a183b0-0e41-7171-aea8-089b52784287",
        "storage_key": "property/6767906449167641/01a183b0-0e41-7171-aea8-089b52784287.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek stainless steel appliances, including a refrigerator, oven, and microwave, complemented by light gray cabinetry and granite countertops.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a black refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/21-web-or-mls-Jons%20Crk%20Ln-S1710-015.jpg"
    },
    {
      "id": "ec_fd88afa45f82bed0300e06ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-9489-753e-8d59-15e643cca111.webp",
      "image_media": {
        "alt_text": "Living room with a couch, chairs, coffee table, TV, and a door leading outside.",
        "public_id": "01a15ec5-9489-753e-8d59-15e643cca111",
        "storage_key": "property/6767906449167641/01a15ec5-9489-753e-8d59-15e643cca111.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax and unwind in the spacious living area of your new apartment. Features include a large TV, comfortable seating, and access to the outdoors.",
      "link": "false",
      "alt_text": "A living room with a beige couch, a coffee table, and a flat-screen TV mounted on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/9-web-or-mls-Jons%20Crk%20Ln-S1710-007%20virtually%20staged.jpg"
    },
    {
      "id": "ec_46e4380ea3fd7b673512cafc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-8fba-7729-870c-86c6b338adb5.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and two windows.",
        "public_id": "01a15ec5-8fba-7729-870c-86c6b338adb5",
        "storage_key": "property/6767906449167641/01a15ec5-8fba-7729-870c-86c6b338adb5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring a comfortable queen-size bed, elegant nightstands, and large windows offering scenic views.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and two lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/28-web-or-mls-Jons%20Crk%20Ln-S1710-020%20virtually%20staged.jpg"
    },
    {
      "id": "ec_27d03b402e5d094312d7f192",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-9475-773f-8d33-e1b50ae212f9.webp",
      "image_media": {
        "alt_text": "Bedroom and adjacent bathroom in an apartment.",
        "public_id": "01a15ec5-9475-773f-8d33-e1b50ae212f9",
        "storage_key": "property/6767906449167641/01a15ec5-9475-773f-8d33-e1b50ae212f9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom with hardwood floors, elegant decor, and an en-suite bathroom featuring modern vanities.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/31-web-or-mls-Jons%20Crk%20Ln-S1710-021%20virtually%20staged.jpg"
    },
    {
      "id": "ec_78799cd38930d5f0ee5b1b6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-afd9-72b3-874e-91160607dad1.webp",
      "image_media": {
        "alt_text": "Modern home office with a curved desk, laptop, chair, and a tall bookshelf.",
        "public_id": "01a15ec5-afd9-72b3-874e-91160607dad1",
        "storage_key": "property/6767906449167641/01a15ec5-afd9-72b3-874e-91160607dad1.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Create your perfect home office setup in this modern space, complete with a comfortable desk and ample shelving for all your essentials.",
      "link": "false",
      "alt_text": "A room with a desk, chair, and bookshelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/47-web-or-mls-Jons%20Crk%20Ln-S1710-029%20virtually%20staged.jpg"
    },
    {
      "id": "ec_cfa1972c625fa1c66d28bae1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-b39e-71c9-a04b-f1c53095d054.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, granite countertops, and white shower/tub.",
        "public_id": "01a15ec5-b39e-71c9-a04b-f1c53095d054",
        "storage_key": "property/6767906449167641/01a15ec5-b39e-71c9-a04b-f1c53095d054.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, modern fixtures, and a clean white shower and tub combination.",
      "link": "false",
      "alt_text": "A bathroom with a large mirror, a sink with a marble countertop, a toilet, and a shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/51-web-or-mls-Jons%20Crk%20Ln-S1710-031%20virtually%20staged.jpg"
    },
    {
      "id": "ec_68dc8c3c89ce523a3d8d75b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-b5d8-71ca-802c-3638a63a13db.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, and a large window view.",
        "public_id": "01a15ec5-b5d8-71ca-802c-3638a63a13db",
        "storage_key": "property/6767906449167641/01a15ec5-b5d8-71ca-802c-3638a63a13db.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A beautifully appointed bedroom featuring a comfortable queen-sized bed, elegant nightstands with lamps, and a large window offering views of the surrounding neighborhood.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/43-web-or-mls-Jons%20Crk%20Ln-S1710-027%20virtually%20staged.jpg"
    },
    {
      "id": "ec_4a48ef069539cdd54ad223eb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-9480-743f-960c-821068139ae4.webp",
      "image_media": {
        "alt_text": "Organized closet with shirts, jackets, pants, and folded towels.",
        "public_id": "01a15ec5-9480-743f-960c-821068139ae4",
        "storage_key": "property/6767906449167641/01a15ec5-9480-743f-960c-821068139ae4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space for clothing and accessories.",
      "link": "false",
      "alt_text": "A white closet with clothes and shoes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/38-web-or-mls-Jons%20Crk%20Ln-S1710-024%20virtually%20staged.jpg"
    },
    {
      "id": "ec_75424f063da7a7174e355b9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-94cb-77c5-a337-a57b9bec6d57.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertop, and large mirror.",
        "public_id": "01a15ec5-94cb-77c5-a337-a57b9bec6d57",
        "storage_key": "property/6767906449167641/01a15ec5-94cb-77c5-a337-a57b9bec6d57.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a spacious double vanity with granite countertops and a large, illuminating mirror.",
      "link": "false",
      "alt_text": "A bathroom with a marble countertop and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/35-web-or-mls-Jons%20Crk%20Ln-S1710-023%20virtually%20staged.jpg"
    },
    {
      "id": "ec_f355cbd7fffb5a8b2834b16b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1a37-72d8-b919-b29840276327.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, vanity, toilet, and walk-in shower.",
        "public_id": "01a183b0-1a37-72d8-b919-b29840276327",
        "storage_key": "property/6767906449167641/01a183b0-1a37-72d8-b919-b29840276327.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed bathroom, featuring a sleek granite countertop, a spacious vanity, a modern toilet, and a convenient walk-in shower.",
      "link": "false",
      "alt_text": "A bathroom with a marble countertop and white fixtures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/32-web-or-mls-Jons%20Crk%20Ln-S1710-022.jpg"
    },
    {
      "id": "ec_f0e195eb35e088dfbb3abfa4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1a30-7758-9d20-45adf7677240.webp",
      "image_media": {
        "alt_text": "White washer and dryer in a laundry room.",
        "public_id": "01a183b0-1a30-7758-9d20-45adf7677240",
        "storage_key": "property/6767906449167641/01a183b0-1a30-7758-9d20-45adf7677240.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry care.",
      "link": "false",
      "alt_text": "Two white front loading washing machines in a small laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/39-web-or-mls-Jons%20Crk%20Ln-S1710-025.jpg"
    },
    {
      "id": "ec_dd39117f9a688733bd4c1429",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1c3c-742a-b8d6-06809c137c29.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with private fenced backyards and green lawns.",
        "public_id": "01a183b0-1c3c-742a-b8d6-06809c137c29",
        "storage_key": "property/6767906449167641/01a183b0-1c3c-742a-b8d6-06809c137c29.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Step outside to your private backyard, perfect for relaxing or entertaining. Enjoy the spacious green lawn and fencing for added privacy.",
      "link": "false",
      "alt_text": "A grey house with a black fence and a green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/60-web-or-mls-Jons%20Crk%20Ln-S1710-040.jpg"
    },
    {
      "id": "ec_3a76e4791fc16b1397ddf26e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1eb2-70ae-b90c-fd5a8f27fb19.webp",
      "image_media": {
        "alt_text": "Playground with swings, slides, and climbing structures.",
        "public_id": "01a183b0-1eb2-70ae-b90c-fd5a8f27fb19",
        "storage_key": "property/6767906449167641/01a183b0-1eb2-70ae-b90c-fd5a8f27fb19.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring swings, slides, and climbing structures for all ages.",
      "link": "false",
      "alt_text": "A playground with a green slide and monkey bars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/64-web-or-mls-Jons%20Crk%20Ln-1710-903.jpg"
    },
    {
      "id": "ec_2cbdb76d6898c95b0d104ae8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1f14-719f-905c-e4d4ce284c6a.webp",
      "image_media": {
        "alt_text": "Playground with slide, swings, and climbing structure in a residential community.",
        "public_id": "01a183b0-1f14-719f-905c-e4d4ce284c6a",
        "storage_key": "property/6767906449167641/01a183b0-1f14-719f-905c-e4d4ce284c6a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring a slide, swings, and a unique climbing structure. Perfect for family-friendly living.",
      "link": "false",
      "alt_text": "A playground with a slide and a sandbox in the middle of a grassy area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/63-web-or-mls-Jons%20Crk%20Ln-1710-902.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_766bd015-2d03-427b-ae9e-67f1060f4159",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Harbor Inn Seafood",
      "poi_type": "Restaurants",
      "poi_address": "8805 University E Dr, Charlotte, NC 28213, USA",
      "poi_short_description": "Fried seafood platters, flounder, crab legs, and other seafood dishes served in an informal setting.",
      "poi_long_description": "Fried seafood platters, flounder, crab legs, and other seafood dishes served in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-f170-72dd-940b-7d7230b9b834.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-f170-72dd-940b-7d7230b9b834",
        "storage_key": "property/6767906449167641/019fec32-f170-72dd-940b-7d7230b9b834.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://harborinnseafoodcharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14189390431122806115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harbor-inn-seafood",
      "poi_latitude": "35.2870886",
      "poi_longitude": "-80.72820829999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-494-8901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7D5Fq4eVIgRY9VmImvX6sQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_44a7f11a-025a-46dd-b641-23c06f4be523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "8936 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-df59-71da-911c-5e91c4dc71ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-df59-71da-911c-5e91c4dc71ee",
        "storage_key": "property/6767906449167641/019fec32-df59-71da-911c-5e91c4dc71ee.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://cava.com/locations/university-place-nc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16556343140839884598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cava",
      "poi_latitude": "35.3099239",
      "poi_longitude": "-80.74786139999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-243-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7psTCMcVIgRNoc8CV7yw-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_1ba95c98-4792-4603-a591-88a5aadf2ac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Piada Italian Street Food",
      "poi_type": "Restaurants",
      "poi_address": "8932 J M Keynes Dr #120, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-order restaurant serving design-your-own Italian food including wraps, pastas & salads.",
      "poi_long_description": "Counter-order restaurant serving design-your-own Italian food including wraps, pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-e4f1-722e-9c8f-f2642b55ef08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-e4f1-722e-9c8f-f2642b55ef08",
        "storage_key": "property/6767906449167641/019fec32-e4f1-722e-9c8f-f2642b55ef08.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://mypiada.com/locations/university-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=11497166655809148898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piada-italian-street-food",
      "poi_latitude": "35.309612",
      "poi_longitude": "-80.7479",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-885-1456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcULXMkdVIgR4lf4qigkjp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_49f54948-90a1-44c5-940f-712c8d6884bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Famous Toastery",
      "poi_type": "Restaurants",
      "poi_address": "8933 J M Keynes Dr #2, Charlotte, NC 28262, USA",
      "poi_short_description": "Comfortable setting for classic & creative takes on American breakfast, brunch & lunch dishes.",
      "poi_long_description": "Comfortable setting for classic & creative takes on American breakfast, brunch & lunch dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-df81-7027-9015-3a7d036dabc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-df81-7027-9015-3a7d036dabc8",
        "storage_key": "property/6767906449167641/019fec32-df81-7027-9015-3a7d036dabc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famoustoastery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=615834463933113794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "famous-toastery",
      "poi_latitude": "35.3103407",
      "poi_longitude": "-80.7494772",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-503-9599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB74QVzscVIgRwiUtny7iiwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e414839c-0d61-446a-9a70-9efd9df5011a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Boardwalk Billy's Raw Bar and Ribs",
      "poi_type": "Restaurants",
      "poi_address": "9005 J M Keynes Dr #2, Charlotte, NC 28262, USA",
      "poi_short_description": "Festive, easygoing hangout featuring BBQ, seafood & drinks plus a covered patio & a lively bar.",
      "poi_long_description": "Festive, easygoing hangout featuring BBQ, seafood & drinks plus a covered patio & a lively bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-8777-7729-af48-c43de124dee8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8777-7729-af48-c43de124dee8",
        "storage_key": "property/6767906449167641/019fec2f-8777-7729-af48-c43de124dee8.webp",
        "width": 1280,
        "height": 573
      },
      "poi_business_url": "https://university.boardwalkbillys.com/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=9333202762111351091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boardwalk-billys-raw-bar-and-ribs",
      "poi_latitude": "35.3106616",
      "poi_longitude": "-80.7495888",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-503-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7a5WzscVIgRM3lXdHYyhoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d179a6c5-31ab-47ba-b8bf-f410accd21b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "City Barbeque",
      "poi_type": "Restaurants",
      "poi_address": "8948 J M Keynes Dr #420, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-serve smokehouse chain offering classic barbecue fare in down-home settings.",
      "poi_long_description": "Counter-serve smokehouse chain offering classic barbecue fare in down-home settings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-e143-733c-8a5f-76ba8d77d46b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-e143-733c-8a5f-76ba8d77d46b",
        "storage_key": "property/6767906449167641/019fec32-e143-733c-8a5f-76ba8d77d46b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.citybbq.com/?utm_campaign=GMB&utm_medium=GBM&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3573752813142911568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-barbeque",
      "poi_latitude": "35.3103598",
      "poi_longitude": "-80.7468131",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-278-8015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTpGvjwcVIgRUKpvvj-FmDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_3a6332f0-8417-456d-92b2-8ef7639e7284",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Sabor Latin Street Grill",
      "poi_type": "Restaurants",
      "poi_address": "9325 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Tacos, quesadillas, and other Latin street food served in a counter-serve environment with daily specials.",
      "poi_long_description": "Tacos, quesadillas, and other Latin street food served in a counter-serve environment with daily specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-e4e5-772c-9afa-09669edef772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-e4e5-772c-9afa-09669edef772",
        "storage_key": "property/6767906449167641/019fec32-e4e5-772c-9afa-09669edef772.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saborlatingrill.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-website-university",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606994444976766843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sabor-latin-street-grill",
      "poi_latitude": "35.3107152",
      "poi_longitude": "-80.7460624",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-819-7274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2eKxFIdVIgRe78pKqcK9a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "custom_085350b9-702a-4393-80ae-ff74912fe589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Blaze Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8948 J M Keynes Dr #400, Charlotte, NC 28262, USA",
      "poi_short_description": "Hip counter-serve pizzeria dishing up crispy, thin-crust pies made with creative toppings & sauces.",
      "poi_long_description": "Hip counter-serve pizzeria dishing up crispy, thin-crust pies made with creative toppings & sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-e41b-726e-b419-0b74ec516df9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-e41b-726e-b419-0b74ec516df9",
        "storage_key": "property/6767906449167641/019fec32-e41b-726e-b419-0b74ec516df9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.blazepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17455837503924574762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blaze-pizza",
      "poi_latitude": "35.3105691",
      "poi_longitude": "-80.7469788",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-217-4306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZsy2jwcVIgRKppdjrmXP_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_3deab14f-857d-441e-a133-0a489520fd60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Thai House - University",
      "poi_type": "Restaurants",
      "poi_address": "230 E W.T. Harris Blvd B9, Charlotte, NC 28262, USA",
      "poi_short_description": "Classic Asian options served in a relaxed space with traditional accents like carved-wood art.",
      "poi_long_description": "Classic Asian options served in a relaxed space with traditional accents like carved-wood art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-e144-746b-95f2-6a9ec949a423.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-e144-746b-95f2-6a9ec949a423",
        "storage_key": "property/6767906449167641/019fec32-e144-746b-95f2-6a9ec949a423.webp",
        "width": 1280,
        "height": 883
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6062336256872962543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-house---university",
      "poi_latitude": "35.303948",
      "poi_longitude": "-80.74980699999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-717-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6-6riYcVIgR71niu7S-IVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_f96cc4f2-bd78-41e2-a4a3-75bb2ea72396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "6925 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-e71e-71bd-af2b-dd09f3a27162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-e71e-71bd-af2b-dd09f3a27162",
        "storage_key": "property/6767906449167641/019fec32-e71e-71bd-af2b-dd09f3a27162.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1021225",
      "poi_directions_map_url": "https://maps.google.com/?cid=3479079474493595309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "35.29072",
      "poi_longitude": "-80.7653",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-266-7269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-3362-70b2-a77c-2055a2324d94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-3362-70b2-a77c-2055a2324d94",
        "storage_key": "property/6767906449167641/019fec33-3362-70b2-a77c-2055a2324d94.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJfZEi84ceVIgRrR6LXlksSDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c139ab40-1cc0-4815-92f5-24c84d0f14b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-eb29-71ad-9bf4-6e53e1652a0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-eb29-71ad-9bf4-6e53e1652a0e",
        "storage_key": "property/6767906449167641/019fec32-eb29-71ad-9bf4-6e53e1652a0e.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/nc/charlotte/town-center-plaza/097/00258?cid=loc_09700258_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14672821738330894495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "35.2961576",
      "poi_longitude": "-80.73830749999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-593-1395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be5e-748d-b145-1a0b4adf4d7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be5e-748d-b145-1a0b4adf4d7a",
        "storage_key": "property/6767906449167641/019fec2f-be5e-748d-b145-1a0b4adf4d7a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcaHUioZVIgRn7DXjaFVoMs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bbc40241-3db3-45ec-8edb-ea6232b34960",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8120 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-ed9d-706c-ad40-66bcc5ffe6b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-ed9d-706c-ad40-66bcc5ffe6b6",
        "storage_key": "property/6767906449167641/019fec32-ed9d-706c-ad40-66bcc5ffe6b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ne-charlotte/1081",
      "poi_directions_map_url": "https://maps.google.com/?cid=13592394189975419888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.2929967",
      "poi_longitude": "-80.74573989999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-599-6332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be87-717e-819f-a807d3170da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be87-717e-819f-a807d3170da1",
        "storage_key": "property/6767906449167641/019fec2f-be87-717e-819f-a807d3170da1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ05zW0ZgeVIgR8HuRDIDiobw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_86475e2e-fb7c-49ef-8c02-6cce071cecf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "IKEA",
      "poi_type": "Shopping & Retail",
      "poi_address": "8300 Ikea Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_long_description": "Scandinavian chain selling ready-to-assemble furniture, plus textiles, lighting & home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-8c97-7707-b4bc-d5d59c74c7cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8c97-7707-b4bc-d5d59c74c7cf",
        "storage_key": "property/6767906449167641/019fec2f-8c97-7707-b4bc-d5d59c74c7cf.webp",
        "width": 1280,
        "height": 578
      },
      "poi_business_url": "https://www.ikea.com/us/en/stores/charlotte/?utm_source=google&utm_medium=organic&utm_campaign=map&utm_content=charlotte",
      "poi_directions_map_url": "https://maps.google.com/?cid=8666071200226601882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ikea",
      "poi_latitude": "35.2935168",
      "poi_longitude": "-80.7647415",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-888-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be87-717e-819f-a807d3170da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be87-717e-819f-a807d3170da1",
        "storage_key": "property/6767906449167641/019fec2f-be87-717e-819f-a807d3170da1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNUGiFYceVIgRmuu_f9cRRHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_1d242ad9-eb92-48d5-9810-d52358a2ab2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Newell Elementary School",
      "poi_type": "Education",
      "poi_address": "325 Rocky River Rd W, Charlotte, NC 28213, USA",
      "poi_short_description": "Public elementary school, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public elementary school, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://newelles.cmsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8833122033534217963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newell-elementary-school",
      "poi_latitude": "35.2867519",
      "poi_longitude": "-80.7535508",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 980-343-6820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be58-74ff-91ad-6a90dc6236ce",
        "storage_key": "property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ216MvroeVIgR6657irCNlXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0fa28b29-465a-44be-9420-a3dd1e03f536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Martin Luther King, Jr. Middle",
      "poi_type": "Education",
      "poi_address": "500 Bilmark Ave, Charlotte, NC 28213, USA",
      "poi_short_description": "Public middle school, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public middle school, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-f681-7718-9e08-136bac6f8bfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-f681-7718-9e08-136bac6f8bfa",
        "storage_key": "property/6767906449167641/019fec32-f681-7718-9e08-136bac6f8bfa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cmsk12.org/martinlutherkingjrMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5888650442415146741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-luther-king-jr-middle",
      "poi_latitude": "35.26339189999999",
      "poi_longitude": "-80.7786995",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-343-0698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be58-74ff-91ad-6a90dc6236ce",
        "storage_key": "property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpU7tak4eVIgR9QaawmCwuFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ecd605f4-4552-441f-a407-85e5b7890ab7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Dorothy J Vaughan Academy of Technology",
      "poi_type": "Education",
      "poi_address": "8601 Old Concord Rd, Charlotte, NC 28213, USA",
      "poi_short_description": "Public magnet school with a technology focus, Charlotte-Mecklenburg Schools.",
      "poi_long_description": "Public magnet school with a technology focus, Charlotte-Mecklenburg Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-f615-732a-acff-9d3f44662065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-f615-732a-acff-9d3f44662065",
        "storage_key": "property/6767906449167641/019fec32-f615-732a-acff-9d3f44662065.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/dorothyjvaughanES",
      "poi_directions_map_url": "https://maps.google.com/?cid=8768757392524256466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorothy-j-vaughan-academy-of-technology",
      "poi_latitude": "35.2855725",
      "poi_longitude": "-80.733695",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 980-343-0030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be58-74ff-91ad-6a90dc6236ce",
        "storage_key": "property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5XfvvroeVIgR0iT9vmPisHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5ab3f3a0-af17-4b4a-a05f-53d08265c64c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "La Petite Academy on East W.T. Harris Blvd.",
      "poi_type": "Education",
      "poi_address": "917 E W.T. Harris Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "Chain preschool offering learning programs for infants, toddlers, preschoolers, and pre-K students.",
      "poi_long_description": "Chain preschool offering learning programs for infants, toddlers, preschoolers, and pre-K students.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-fb15-7708-863e-0529abd93dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-fb15-7708-863e-0529abd93dc0",
        "storage_key": "property/6767906449167641/019fec32-fb15-7708-863e-0529abd93dc0.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/charlotte-nc-7468/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7468",
      "poi_directions_map_url": "https://maps.google.com/?cid=15163205819505458802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-east-wt-harris-blvd",
      "poi_latitude": "35.2946621",
      "poi_longitude": "-80.74074019999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be58-74ff-91ad-6a90dc6236ce",
        "storage_key": "property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4yVqCKEeVIgRcj7Cz1qHbtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_304b4bc5-c23b-452c-81b4-2dd2e109aab9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Reedy Creek Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2986 ROCKY RIVER RD, Charlotte, NC 28215, USA",
      "poi_short_description": "Nature center with animals & a gift shop in a 927-acre preserve with fishing, hiking & more.",
      "poi_long_description": "Nature center with animals & a gift shop in a 927-acre preserve with fishing, hiking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-fd09-7475-a030-42ad922f92aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-fd09-7475-a030-42ad922f92aa",
        "storage_key": "property/6767906449167641/019fec32-fd09-7475-a030-42ad922f92aa.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3576989697573525763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-nature-center",
      "poi_latitude": "35.261767",
      "poi_longitude": "-80.71938000000002",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c13f-72af-960c-b02cc85abb41",
        "storage_key": "property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRFBPi0ZVIgRAxkaoS0FpDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_e012cfd4-c94f-43d1-8e44-44e36786fda7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-a6b6-764f-a5ce-3a51e66608a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a6b6-764f-a5ce-3a51e66608a3",
        "storage_key": "property/6767906449167641/019fec2f-a6b6-764f-a5ce-3a51e66608a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_fadf25bf-3096-49fa-95c6-bce1224edfde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-ff7d-751b-bda1-5e469341cdde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-ff7d-751b-bda1-5e469341cdde",
        "storage_key": "property/6767906449167641/019fec32-ff7d-751b-bda1-5e469341cdde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3273693",
      "poi_longitude": "-80.71079309999999",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_6487fa0c-4f70-4ed5-a52c-650176781f5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Topgolf Charlotte - University",
      "poi_type": "Entertainment",
      "poi_address": "9110 Drivers Wy, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-8785-74fe-8d1f-618b65010eb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8785-74fe-8d1f-618b65010eb4",
        "storage_key": "property/6767906449167641/019fec2f-8785-74fe-8d1f-618b65010eb4.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "https://topgolf.com/us/charlotte-university/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14916876276335703365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-charlotte---university",
      "poi_latitude": "35.2875467",
      "poi_longitude": "-80.7702764",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-701-0450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be70-770c-8d6c-b9b98c7f1e93",
        "storage_key": "property/6767906449167641/019fec2f-be70-770c-8d6c-b9b98c7f1e93.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiWWWOZUfVIgRRfVwufBjA88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_84e09275-2e54-4700-8e20-5922e332afc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "AvidXchange Music Factory",
      "poi_type": "Entertainment",
      "poi_address": "1000 Nc Music Factory Blvd, Charlotte, NC 28206, USA",
      "poi_short_description": "Large leisure and dining complex with a beer garden, multiple restaurants, comedy clubs and concert venues.",
      "poi_long_description": "Large leisure and dining complex with a beer garden, multiple restaurants, comedy clubs and concert venues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-0346-717f-93db-798c319dfbf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-0346-717f-93db-798c319dfbf3",
        "storage_key": "property/6767906449167641/019fec33-0346-717f-93db-798c319dfbf3.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.avidxchangemusicfactory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15900751944736699666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avidxchange-music-factory",
      "poi_latitude": "35.2401967",
      "poi_longitude": "-80.84582019999999",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-916-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWL3zzegVogREvWh36XRqtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_6512487c-f5ea-440a-8a18-77ce2ad782e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Neighborhood Theatre",
      "poi_type": "Entertainment",
      "poi_address": "511 E 36th St, Charlotte, NC 28205, USA",
      "poi_short_description": "Live music venue hosting acts in a variety of genres & DJ-driven parties, with VIP seating & bar.",
      "poi_long_description": "Live music venue hosting acts in a variety of genres & DJ-driven parties, with VIP seating & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-ffd2-77fb-8ab8-dbc8150b7715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-ffd2-77fb-8ab8-dbc8150b7715",
        "storage_key": "property/6767906449167641/019fec32-ffd2-77fb-8ab8-dbc8150b7715.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.neighborhoodtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242965911959922312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neighborhood-theatre",
      "poi_latitude": "35.24740930000001",
      "poi_longitude": "-80.8040699",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-942-7997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl94FGdofVIgRiGaWg6HA56k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_8449d5fd-b7e0-474f-adfb-d9ca7d10a772",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9325 JW Clay Blvd Ste 221, Charlotte, NC 28262, USA",
      "poi_short_description": "Walk-in urgent care clinic, Atrium Health.",
      "poi_long_description": "Walk-in urgent care clinic, Atrium Health.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-0ea3-771e-b7d3-ef0c083c8a96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-0ea3-771e-b7d3-ef0c083c8a96",
        "storage_key": "property/6767906449167641/019fec33-0ea3-771e-b7d3-ef0c083c8a96.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5661548961259477027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3107795",
      "poi_longitude": "-80.7457122",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-863-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUFVFxgdVIgRI1hausjckU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_cad8480c-9a76-49d6-bc86-e20fd72a8e0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8120 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "Pharmacy and drugstore chain.",
      "poi_long_description": "Pharmacy and drugstore chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-0ba3-749c-b7a4-fcfbe7fb454c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-0ba3-749c-b7a4-fcfbe7fb454c",
        "storage_key": "property/6767906449167641/019fec33-0ba3-749c-b7a4-fcfbe7fb454c.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/8120-university-city-blvd-charlotte-nc-28213/storeid=16461?WT.mc_id=LS_GOOGLE_RX_16461",
      "poi_directions_map_url": "https://maps.google.com/?cid=3252503274417569303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.2929967",
      "poi_longitude": "-80.74573989999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-599-3472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-3376-73ef-b88a-5803e2635e4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-3376-73ef-b88a-5803e2635e4f",
        "storage_key": "property/6767906449167641/019fec33-3376-73ef-b88a-5803e2635e4f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05zW0ZgeVIgRFz503n42Iy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_97fe4eae-2999-4c95-84fc-09e816ef2ab0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7735 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_long_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-0dea-74c2-b235-f109686cd912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-0dea-74c2-b235-f109686cd912",
        "storage_key": "property/6767906449167641/019fec33-0dea-74c2-b235-f109686cd912.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2134-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7693588847703310125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2951583",
      "poi_longitude": "-80.7581024",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-547-0525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be87-717e-819f-a807d3170da1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be87-717e-819f-a807d3170da1",
        "storage_key": "property/6767906449167641/019fec2f-be87-717e-819f-a807d3170da1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9wzzDDAcVIgRLT9Da0sexWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b206642f-9312-4545-8204-818323da52f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10215 University City Blvd B, Charlotte, NC 28213, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning beds, and 24-hour access.",
      "poi_long_description": "Chain gym featuring a variety of equipment, tanning beds, and 24-hour access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-9717-715c-a7bd-de101954124c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9717-715c-a7bd-de101954124c",
        "storage_key": "property/6767906449167641/019fec2f-9717-715c-a7bd-de101954124c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-university-blvd-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15550441792175585086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.31210069999999",
      "poi_longitude": "-80.713909",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-548-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYakZvEbVIgRPrcDk2tEztc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_96cf6fa6-7a81-4d9f-9e4d-8b8b29d75b15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Reedy Creek Park Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Charlotte, NC 28215, USA",
      "poi_short_description": "Expansive fenced in, off-leash dog park with separate areas for small and large breeds.",
      "poi_long_description": "Expansive fenced in, off-leash dog park with separate areas for small and large breeds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-13d4-775b-9639-898aef9ee699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-13d4-775b-9639-898aef9ee699",
        "storage_key": "property/6767906449167641/019fec33-13d4-775b-9639-898aef9ee699.webp",
        "width": 872,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4878713924716183801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-park-dog-park",
      "poi_latitude": "35.2747749",
      "poi_longitude": "-80.71639669999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c13f-72af-960c-b02cc85abb41",
        "storage_key": "property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbvY7yYZVIgR-cB1S3estEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_37b804f6-cd32-4344-8109-6294ba54bebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Tom Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "919 Tom Hunter Rd, Charlotte, NC 28213, USA",
      "poi_short_description": "Children's play areas and picnic tables at a park with a basketball court.",
      "poi_long_description": "Children's play areas and picnic tables at a park with a basketball court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-180b-756e-bc77-c663d96f9d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-180b-756e-bc77-c663d96f9d74",
        "storage_key": "property/6767906449167641/019fec33-180b-756e-bc77-c663d96f9d74.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3034716072445602436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-hunter-park",
      "poi_latitude": "35.2772068",
      "poi_longitude": "-80.78143419999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c13f-72af-960c-b02cc85abb41",
        "storage_key": "property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUrSM0IeVIgRhOpJdDB6HSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4afddc6a-a64f-431b-8fda-f98be6b3e5dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Toby Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "805 Rocky River Rd W, Charlotte, NC 28213, USA",
      "poi_short_description": "Paved greenway trail along Toby Creek, part of the Mecklenburg County greenway network.",
      "poi_long_description": "Paved greenway trail along Toby Creek, part of the Mecklenburg County greenway network.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-1558-75eb-bf79-c0629f8eef72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-1558-75eb-bf79-c0629f8eef72",
        "storage_key": "property/6767906449167641/019fec33-1558-75eb-bf79-c0629f8eef72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/greenways",
      "poi_directions_map_url": "https://maps.google.com/?cid=503254549599039572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toby-creek-greenway",
      "poi_latitude": "35.2855733",
      "poi_longitude": "-80.7483759",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c13f-72af-960c-b02cc85abb41",
        "storage_key": "property/6767906449167641/019fec2f-c13f-72af-960c-b02cc85abb41.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6hIC9IfVIgRVDBztFjr-wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7aceae51-e824-48fb-9059-80097b0618c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Clarks Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9729 Mallard Creek Rd, Charlotte, NC 28267, USA",
      "poi_short_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_long_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-1863-710d-a5ce-8d6dfc014789.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-1863-710d-a5ce-8d6dfc014789",
        "storage_key": "property/6767906449167641/019fec33-1863-710d-a5ce-8d6dfc014789.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285017145315421591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-greenway",
      "poi_latitude": "35.3345362",
      "poi_longitude": "-80.7740029",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-338d-7167-8828-f7c724623efd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-338d-7167-8828-f7c724623efd",
        "storage_key": "property/6767906449167641/019fec33-338d-7167-8828-f7c724623efd.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWo_U0gcVIgRl-3jjGiTPsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_7d1af619-bf53-422c-a627-3c61aab6eeb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Old Concord Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28213, USA",
      "poi_short_description": "LYNX Blue Line light rail station (CATS).",
      "poi_long_description": "LYNX Blue Line light rail station (CATS).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-b217-719a-97e6-e6ab696e5c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-b217-719a-97e6-e6ab696e5c90",
        "storage_key": "property/6767906449167641/019fec2f-b217-719a-97e6-e6ab696e5c90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125097527445389047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-concord-road-station",
      "poi_latitude": "35.2599158",
      "poi_longitude": "-80.77273230000002",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c14e-72b2-a0fd-d4487d24dd37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c14e-72b2-a0fd-d4487d24dd37",
        "storage_key": "property/6767906449167641/019fec2f-c14e-72b2-a0fd-d4487d24dd37.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZhR5lMeVIgR936FpBAk59E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_f51ff7c3-5a4e-4bf0-8f3c-fe5e9e8ddd13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "LYNX Blue Line light rail station (CATS).",
      "poi_long_description": "LYNX Blue Line light rail station (CATS).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-afc0-771b-8fbc-f81c0e6226a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-afc0-771b-8fbc-f81c0e6226a2",
        "storage_key": "property/6767906449167641/019fec2f-afc0-771b-8fbc-f81c0e6226a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c14e-72b2-a0fd-d4487d24dd37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c14e-72b2-a0fd-d4487d24dd37",
        "storage_key": "property/6767906449167641/019fec2f-c14e-72b2-a0fd-d4487d24dd37.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4b58ea64-9073-49c4-b2ab-70adf5a3ab06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Tom Hunter Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28213, USA",
      "poi_short_description": "LYNX Blue Line light rail station (CATS).",
      "poi_long_description": "LYNX Blue Line light rail station (CATS).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-204c-73dc-9fca-ff113e71f551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-204c-73dc-9fca-ff113e71f551",
        "storage_key": "property/6767906449167641/019fec33-204c-73dc-9fca-ff113e71f551.webp",
        "width": 719,
        "height": 490
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2039373716308956755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-hunter-station",
      "poi_latitude": "35.2779461",
      "poi_longitude": "-80.76628629999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-c14e-72b2-a0fd-d4487d24dd37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-c14e-72b2-a0fd-d4487d24dd37",
        "storage_key": "property/6767906449167641/019fec2f-c14e-72b2-a0fd-d4487d24dd37.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5VbfjF8eVIgRUxbdBJdPTRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e7223d89-844b-4cf9-a150-c6b564db2806",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-23ae-754b-85bb-950d89279ae6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-23ae-754b-85bb-950d89279ae6",
        "storage_key": "property/6767906449167641/019fec33-23ae-754b-85bb-950d89279ae6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 7 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-3367-7198-a7f8-d84b46f2b443.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec33-3367-7198-a7f8-d84b46f2b443",
        "storage_key": "property/6767906449167641/019fec33-3367-7198-a7f8-d84b46f2b443.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_ea0cba92-ccbc-4bba-9045-7649d4df1aca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "Public research university in University City, part of the UNC System.",
      "poi_long_description": "Public research university in University City, part of the UNC System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-8c50-77c1-9a55-6ddcb457fd25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8c50-77c1-9a55-6ddcb457fd25",
        "storage_key": "property/6767906449167641/019fec2f-8c50-77c1-9a55-6ddcb457fd25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be58-74ff-91ad-6a90dc6236ce",
        "storage_key": "property/6767906449167641/019fec2f-be58-74ff-91ad-6a90dc6236ce.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dc5926ac-fad7-4c50-bcbe-37ebb1cfedc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Atrium Health University City",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Hospital in University City, part of Atrium Health.",
      "poi_long_description": "Hospital in University City, part of Atrium Health.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-a34e-778a-8668-d101875ab9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a34e-778a-8668-d101875ab9ca",
        "storage_key": "property/6767906449167641/019fec2f-a34e-778a-8668-d101875ab9ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-be91-7602-bec4-751359598a3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-be91-7602-bec4-751359598a3e",
        "storage_key": "property/6767906449167641/019fec2f-be91-7602-bec4-751359598a3e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c7f37078-b125-4a14-8318-2b90d542726c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Bank of America Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 N Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Bank of America's headquarters tower in Uptown Charlotte.",
      "poi_long_description": "Bank of America's headquarters tower in Uptown Charlotte.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-280e-75db-b897-d4bf2913e8cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-280e-75db-b897-d4bf2913e8cc",
        "storage_key": "property/6767906449167641/019fec33-280e-75db-b897-d4bf2913e8cc.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.bankofamerica.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6278332633274031391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bank-of-america-corporate-center",
      "poi_latitude": "35.2275159",
      "poi_longitude": "-80.8421672",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-432-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3DKDCWgVogRH50KFEQeIVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_da073200-1766-49af-977e-e77f16255315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Duke Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "525 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Duke Energy corporate offices, Uptown Charlotte.",
      "poi_long_description": "Duke Energy corporate offices, Uptown Charlotte.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-2734-76d2-a067-d69b97c1a2c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-2734-76d2-a067-d69b97c1a2c6",
        "storage_key": "property/6767906449167641/019fec33-2734-76d2-a067-d69b97c1a2c6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.duke-energy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821899997112668324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duke-energy",
      "poi_latitude": "35.2236874",
      "poi_longitude": "-80.84766309999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-774-1226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeckepVqhVogRpJD3TswdCjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c2dce075-fa8a-444b-8c96-2c3cd7a75682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Wells Fargo",
      "poi_type": "Major Employers & Offices",
      "poi_address": "550 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Wells Fargo corporate offices, Uptown Charlotte.",
      "poi_long_description": "Wells Fargo corporate offices, Uptown Charlotte.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-28e1-705f-8eec-d17fbfc3455a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-28e1-705f-8eec-d17fbfc3455a",
        "storage_key": "property/6767906449167641/019fec33-28e1-705f-8eec-d17fbfc3455a.webp",
        "width": 1166,
        "height": 1280
      },
      "poi_business_url": "https://www.wellsfargo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16280400992495862406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wells-fargo",
      "poi_latitude": "35.2238422",
      "poi_longitude": "-80.848736",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-869-3557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8sGRSmgVogRhgKiBnKa7-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7aafe3ff-7a5b-4512-b722-83a8c40bc44e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "Honeywell - Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "855 S Mint St, Charlotte, NC 28202, USA",
      "poi_short_description": "Honeywell global headquarters, Uptown Charlotte.",
      "poi_long_description": "Honeywell global headquarters, Uptown Charlotte.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec33-294a-777d-b8c5-1516c1cafc43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec33-294a-777d-b8c5-1516c1cafc43",
        "storage_key": "property/6767906449167641/019fec33-294a-777d-b8c5-1516c1cafc43.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "http://honeywell.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12375757565827481379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "honeywell---headquarters",
      "poi_latitude": "35.2243349",
      "poi_longitude": "-80.85148199999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 877-841-2840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZcEMXKhVogRI_9_we-Fv6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_289000d1-0124-4f52-899a-ec7be279170f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "poi_name": "University Research Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "David Taylor Dr &, Andrew Carnegie Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Corporate and research office park in University City.",
      "poi_long_description": "Corporate and research office park in University City.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6219936161875630100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-research-park",
      "poi_latitude": "35.321521",
      "poi_longitude": "-80.755825",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-bea3-750b-9a2d-c4a12248afb9",
        "storage_key": "property/6767906449167641/019fec2f-bea3-750b-9a2d-c4a12248afb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwUdBogdVIgRFBg0DvymUVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6f864e00a7b61eafed88f5c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2827b3c6a237c720cc220769",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_cfc94c93bfdf964be1836383",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_924202f463320d0e2ddd033b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_84851d153cf2c8c3c216bcc0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_c01594a385343b49c40a4c20",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "rating": "5",
      "name": "Jennifer Williams",
      "text": "Moving can be stressful, but my move-in experience was anything but. James Doran\nmade the entire process easy and seamless. He was patient, responsive, and had everything prepared and ready when I arrived. It was clear that he genuinely cared about making sure my transition went smoothly. I appreciate all of his help and am looking forward to being part of the community.",
      "date": "2026-05-30",
      "title": "false"
    },
    {
      "id": "ec_87321fcaac3900992bad5b00",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "rating": "5",
      "name": "Ashley Herrera",
      "text": "James Doran has been an exceptional assistance and support in easing the move in process for my family and I; he has remained in constant communication since our first interest in Newell and has consistently remained the same now as residents. Anthony the maintenance man has been extremely helpful as well in scheduling anything we need immediately or at our earliest convenience and working each day to maintain our community. We appreciate everything Newell has to offer so far. -The Koernig family.",
      "date": "2026-05-29",
      "title": "false"
    },
    {
      "id": "ec_f74adbe9e7314647836c6235",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "rating": "5",
      "name": "Trey Grier",
      "text": "Huge shoutout to Anthony from maintenance! He went above and beyond to fix my issue quickly and perfectly. He’s incredibly personable, friendly, and provided amazing customer service. Thanks for making it a great experience, Anthony!",
      "date": "2026-07-10",
      "title": "false"
    },
    {
      "id": "ec_985d01d7bbbc132001b9d679",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "rating": "5",
      "name": "jake Payton",
      "text": "Newell Village has been an outstanding community and the leasing team is phenomenal. Lisa always asks how she can help make your time at Newell better, and James is always walking around with a smile on his face, greeting residents everyday making sure they know he is here for them. Anthony makes sure all maintenance requirements or questions are dealt with promptly.",
      "date": "2026-05-21",
      "title": "false"
    },
    {
      "id": "ec_123165da082ac75418a6f575",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "rating": "5",
      "name": "T Taylor",
      "text": "James has been the best with helping with my move.  He provides great service and kept me informed on the process.  I am so grateful for his assistance!  Nice dude.",
      "date": "2026-05-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6ae26c9f-32c7-43e8-9da7-44b94ad451de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Kent townhome (3 bed, 2.5 bath, 1,467 sq ft)",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec31-8057-76dc-bfd7-4e62f2fe4291.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fec31-8057-76dc-bfd7-4e62f2fe4291",
        "storage_key": "property/6767906449167641/019fec31-8057-76dc-bfd7-4e62f2fe4291.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Kent",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=UHiQtiQcxJC"
    },
    {
      "id": "custom_c52fb535-376a-4829-a66d-2e1d56847885",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Katana townhome (3 bed, 2.5 bath, 1,584 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Katana",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=LWsiZ7DE22x"
    }
  ],
  "faqs": [
    {
      "id": "custom_92513c3d-f180-488a-bf17-fb01a45d110d",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_359491e1-679d-4615-b5cd-0d092d37aadc",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_ae1656f6-28be-457b-b3f8-fdd05e3d3ef0",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_e11f6b21-7804-46cc-be15-93b419742011",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_4a525bc4-3fca-4de1-a9a9-01fef6fb4939",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_6683d38e-7e6a-4d3b-b3d4-ff01528352ce",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_2202a822-7c3f-4616-9ede-46088e4d9ad9",
      "question": "Landscape Services",
      "answer": "Townhomes: $45/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_dfd63508-9cc1-4866-b7f7-ef82fa47beda",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_875e73f1-4802-499d-9154-28581aeb52cb",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_1c45453d-4a81-415f-8297-f6724df85c23",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_2ac1bf58-ea18-44fb-bd60-69545e658d61",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_4e7a3bd6-80d9-4cab-9ec9-01d53c25d40f",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_4174cf1f-e022-41e3-9591-c9d6b5d08257",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_51309f86-03ff-466a-8064-39c763b3ba04",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_18e7ab78-5da0-4de9-9448-fb3bf694105b",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_1d9dd3af-ee5d-454e-8a11-1c9f7b802b94",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_d576c34a-1839-4480-9e20-e4041b4c9513",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_6c28afab-6482-41ee-b607-e1fc9d158bca",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_6042860f-8fa3-4aed-a105-c8f087785c0a",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_9d4c674c3ec024e39c688b8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "2351271",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_9df26888778a3775a1985faf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "2366580",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_6e5f1925803dbd7e960fd321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "yardi",
      "external_id": "2366579",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9a0f-7783-925d-c584e07044b1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Newell Village Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641"
    },
    {
      "lead_collector_id": "01a0abe0-9a89-7618-bf7a-d79bde5addb0",
      "lead_source": "LANDING_PAGE",
      "name": "Newell Village Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-charlotte-nc",
      "search_query": "apartments with in-unit laundry Charlotte NC",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Charlotte, NC",
      "h2_subtitle": "Enjoy convenience at Newell Village with our apartments that include in-unit laundry facilities. Perfectly situated in Charlotte, NC.",
      "page_copy": "Finding the perfect place to live in Charlotte can be challenging, but Newell Village offers the perfect solution with our apartments featuring in-unit laundry. Located in the vibrant Newell South neighborhood, enjoy the ease and efficiency that comes with having laundry facilities right in your home.\n\nThese thoughtfully designed apartments not only offer in-unit laundry but also feature stainless steel appliances, spacious closets, and luxury flooring—all aimed at enhancing your living experience. Coupled with lawn maintenance services and a security deposit alternative, Newell Village in Mecklenburg County is designed for comfortable and convenient living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Charlotte, NC",
      "seo_description": "Discover Newell Village: Apartments with in-unit laundry in Charlotte, NC. Experience unmatched convenience in Newell South.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "luxury-apartments-smart-home-newell-south",
      "search_query": "luxury apartments with smart home technology Newell South",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Smart Tech in Newell South",
      "h2_subtitle": "Experience modern living in Newell South with our luxury apartments equipped with smart home technology. Discover the future of convenience today.",
      "page_copy": "Newell Village offers an unparalleled living experience in the desirable Newell South area with luxury apartments designed for today’s tech-savvy resident. Step into the future with our smart home technology that seamlessly integrates with your lifestyle, enhancing convenience and control.\n\nBeyond technology, our luxury apartments in Newell South boast stainless steel appliances and spacious closets, complemented by premium flooring and a security deposit alternative. Lawn maintenance services add ease, allowing you to fully enjoy life in Mecklenburg County's thriving neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Luxury Apartments in Newell South",
      "seo_description": "Explore Newell Village's luxury apartments in Newell South, featuring smart home technology for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "granite-countertops-closets-apartments-mecklenburg",
      "search_query": "granite countertops spacious closets apartments Mecklenburg County",
      "category": "Amenity",
      "h1_title": "Granite Countertops & Spacious Closets in Apartments",
      "h2_subtitle": "Discover the allure of Newell Village in Mecklenburg County, where granite countertops and spacious closets define our stylish apartments.",
      "page_copy": "In the heart of Mecklenburg County, Newell Village offers chic apartments featuring granite countertops and spacious closets designed for optimal storage and style. These modern touches provide a sophisticated and functional space, making everyday living both easy and elegant.\n\nOur community in Newell South not only boasts exquisite interiors but also offers practical amenities like a security deposit alternative and stainless steel appliances. With luxury flooring and lawn maintenance included, Newell Village ensures every detail enhances your living experience in charming Charlotte, NC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apartments in Mecklenburg",
      "seo_description": "Explore Newell Village apartments with granite countertops and spacious closets in Mecklenburg County, designed for comfort and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "pet-friendly-playground-apartments-charlotte-28213",
      "search_query": "pet-friendly apartments with playground Charlotte 28213",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Playground in 28213",
      "h2_subtitle": "Welcome to Newell Village, where pet-friendly living and a community playground make our apartments a top choice in Charlotte's 28213 area.",
      "page_copy": "At Newell Village in Charlotte's 28213 area, we believe in offering a community where everyone, including pets, feels right at home. Our pet-friendly apartments provide spacious living areas perfect for you and your furry friends to bond and relax. \n\nBeyond your apartment, enjoy access to a community playground that adds fun and leisure to your lifestyle. Located in the lively Newell South neighborhood, residents benefit from stainless steel appliances, spacious closets, and lawn maintenance. Experience a blend of comfort and community designed for all members of your household.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments & Playground in Charlotte",
      "seo_description": "Discover pet-friendly apartments at Newell Village in Charlotte 28213, featuring a fun playground and spacious living for all residents.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "luxurious-apartments-stainless-steel-charlotte-nc",
      "search_query": "luxurious apartments with stainless steel appliances Charlotte NC",
      "category": "Amenity",
      "h1_title": "Luxurious Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Indulge in luxury at Newell Village, where stainless steel appliances enhance the elegance of our Charlotte, NC apartments.",
      "page_copy": "Experience luxurious living at Newell Village in Charlotte, NC, where each apartment is thoughtfully designed with modern stainless steel appliances that bring a sleek elegance to your home. These upscale features reflect both style and functionality, making everyday cooking and cleaning a pleasure.\n\nLocated in Newell South, our apartments offer more than just a beautiful kitchen. Enjoy spacious closets and luxury flooring throughout, along with practical conveniences like lawn maintenance and a security deposit alternative. Discover an elevated lifestyle in a community that meets all your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxurious Apartments with Stainless Steel in Charlotte",
      "seo_description": "Explore luxurious Newell Village apartments in Charlotte, NC, featuring stainless steel appliances and upscale living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-newell-south-charlotte",
      "search_query": "three bedroom apartments in Newell South Charlotte",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Newell South Charlotte",
      "h2_subtitle": "Explore spacious three bedroom apartments at Newell Village, perfectly situated in the vibrant Newell South neighborhood of Charlotte.",
      "page_copy": "Discover comfortable living in Newell South, Charlotte with our three bedroom apartments at Newell Village. Designed to accommodate modern lifestyles, these spacious homes offer ample room for families or individuals who crave extra space. \n\nOur community in Charlotte, NC is well-appointed with stainless steel appliances, spacious closets, and luxurious flooring. With amenities like a security deposit alternative and professional lawn maintenance, living in Newell Village means enjoying convenience and a high standard of living. Situated in a serene, yet vibrant neighborhood, it's the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Newell South, Charlotte",
      "seo_description": "Find three bedroom apartments at Newell Village in Newell South, Charlotte. Spacious and well-equipped for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-north-carolina-charlotte",
      "search_query": "apartments near university of north carolina charlotte",
      "category": "School",
      "h1_title": "Apartments Near University of North Carolina Charlotte",
      "h2_subtitle": "Discover convenience at Newell Village, offering apartments just minutes from the University of North Carolina Charlotte campus.",
      "page_copy": "Located close to the University of North Carolina Charlotte, Newell Village offers an ideal home for students and professionals seeking nearby accommodations. Our apartments are not only conveniently situated but also provide a peaceful retreat in the bustling city of Charlotte.\n\nEnjoy modern living with amenities like stainless steel appliances, spacious closets, and luxury flooring. These features blend perfectly with practical benefits such as our security deposit alternative and lawn maintenance, making daily life simpler. Embrace a community just a short commute away from the university, nestled in the welcoming Newell South neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UNC Charlotte - Newell Village",
      "seo_description": "Find convenient apartments near the University of North Carolina Charlotte at Newell Village, offering modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-close-dubois-center-unc-charlotte",
      "search_query": "apartments close to the dubois center at unc charlotte center city mecklenburg",
      "category": "School",
      "h1_title": "Apartments Close to the Dubois Center",
      "h2_subtitle": "Discover the convenience of Newell Village, with apartments just a short drive from the Dubois Center at UNC Charlotte Center City.",
      "page_copy": "Situated in the thriving Newell South neighborhood of Charlotte, Newell Village offers easy access to the Dubois Center at UNC Charlotte Center City. Our apartments provide the perfect living space for those who want both convenience and comfort in Mecklenburg County.\n\nFeaturing top-tier amenities like stainless steel appliances, luxury flooring, and spacious closets, our community ensures a modern lifestyle. Practical offerings such as a security deposit alternative and professional lawn maintenance simplify daily routines. Enjoy living in a vibrant community while being just minutes away from the cultural and educational activities at the Dubois Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Dubois Center, UNC Charlotte",
      "seo_description": "Live near the Dubois Center at UNC Charlotte. Newell Village offers convenient, modern apartments in the heart of Mecklenburg.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-near-atrium-health-university-city",
      "search_query": "apartments near atrium health university city charlotte nc",
      "category": "Hospital",
      "h1_title": "Apartments Near Atrium Health University City",
      "h2_subtitle": "Live close to Atrium Health University City in Newell Village, offering comfortable apartments in a prime Charlotte location.",
      "page_copy": "Discover the ease of living close to Atrium Health University City with spacious apartments at Newell Village. Located in Newell South, our community is ideally situated for healthcare professionals and those seeking proximity to top medical facilities in Charlotte, NC.\n\nNewell Village offers modern amenities designed to enhance your lifestyle, including stainless steel appliances, luxury flooring, and roomy closets. Enjoy hassle-free living with options like a security deposit alternative and lawn maintenance. Experience a blend of convenience and comfort, all within a welcoming Charlotte neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atrium Health University City Charlotte",
      "seo_description": "Find modern apartments near Atrium Health University City at Newell Village, Charlotte NC, offering an ideal blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-near-reedy-creek-nature-preserve",
      "search_query": "apartments near Reedy Creek Nature Preserve Charlotte",
      "category": "Park",
      "h1_title": "Apartments Near Reedy Creek Nature Preserve",
      "h2_subtitle": "Explore Newell Village, where you can find apartments near the serene Reedy Creek Nature Preserve in Charlotte.",
      "page_copy": "Enjoy living near the beautiful Reedy Creek Nature Preserve by choosing an apartment at Newell Village. Nestled in Charlotte’s vibrant Newell South neighborhood, our community offers a peaceful escape just a short drive from the natural beauty of Reedy Creek.\n\nOur apartments feature contemporary amenities, including stainless steel appliances, expansive closets, and stylish luxury flooring, ensuring a comfortable lifestyle. You'll also benefit from practical solutions like a security deposit alternative and professional lawn maintenance. Embrace living amidst nature while enjoying easy access to everything Charlotte has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Reedy Creek Nature Preserve, Charlotte",
      "seo_description": "Live near Reedy Creek Nature Preserve in Charlotte with Newell Village. Enjoy modern, convenient living in a beautiful, natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "newell-village-apartments-unc-charlotte-botanical-gardens",
      "search_query": "Newell Village apartments close to UNC Charlotte Botanical Gardens",
      "category": "Park",
      "h1_title": "Newell Village Near UNC Charlotte Botanical Gardens",
      "h2_subtitle": "Experience Newell Village, perfectly situated near UNC Charlotte Botanical Gardens, where modern living meets natural beauty.",
      "page_copy": "Discover the ideal blend of nature and city living at Newell Village, conveniently located near the stunning UNC Charlotte Botanical Gardens. Situated in the charming Newell South area of Charlotte, Newell Village provides residents easy access to beautiful botanical displays and garden trails.\n\nOur apartments feature exceptional amenities such as spacious closets, stainless steel appliances, and elegant luxury flooring, ensuring a modern and comfortable environment. Options like a security deposit alternative and professional lawn maintenance make life simpler. Immerse yourself in a community that offers a peaceful escape with quick access to educational and cultural experiences at the UNC Charlotte Botanical Gardens.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Newell Village Near UNC Charlotte Botanical Gardens",
      "seo_description": "Live near UNC Charlotte Botanical Gardens at Newell Village, featuring modern apartments and convenient amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "harrisburg-park-nearby-apartments-newell-south",
      "search_query": "Harrisburg Park nearby apartments in Newell South",
      "category": "Park",
      "h1_title": "Nearby Apartments in Newell South Near Harrisburg Park",
      "h2_subtitle": "Discover Newell Village, offering nearby apartments to Harrisburg Park and ideal living in the vibrant Newell South area.",
      "page_copy": "Explore Newell Village, where you can find the perfect home near Harrisburg Park, nestled in the thriving Newell South neighborhood of Charlotte. This inviting community provides quick access to the outdoor fun and recreational activities available at Harrisburg Park, making it a great choice for those who love outdoor living.\n\nNewell Village boasts a range of desirable features, including stainless steel appliances, spacious closets, and luxurious flooring in each apartment. Enjoy the convenience of a security deposit alternative and included lawn maintenance, making life simpler and more enjoyable. Embrace the best of both worlds with a home that’s close to nature and all the excitement of Charlotte’s Newell South area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments in Newell South Near Harrisburg Park",
      "seo_description": "Find your ideal home in Newell South close to Harrisburg Park. Enjoy modern living and convenient amenities at Newell Village in Charlotte, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-mecklenburg-county-near-nevin-park",
      "search_query": "apartments in Mecklenburg County near Nevin Park",
      "category": "Park",
      "h1_title": "Mecklenburg County Apartments Near Nevin Park",
      "h2_subtitle": "Choose Newell Village, offering apartments in Mecklenburg County close to the picturesque Nevin Park, perfect for nature lovers.",
      "page_copy": "Welcome to Newell Village, where you can find an ideal apartment in the heart of Mecklenburg County, conveniently located near the tranquil Nevin Park. Our community is situated in the vibrant Newell South area of Charlotte, providing residents with easy access to the lush green spaces and recreational opportunities that Nevin Park has to offer.\n\nNewell Village features modern amenities such as stainless steel appliances and spacious closets, along with luxurious flooring. With the added benefit of a security deposit alternative and lawn maintenance services, residents enjoy a hassle-free living experience. Embrace the serenity of nature while being minutes away from the dynamic lifestyle of Charlotte in our well-appointed apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mecklenburg County Apartments Near Nevin Park",
      "seo_description": "Discover Newell Village, offering modern Mecklenburg County apartments close to Nevin Park, with outstanding amenities and a prime location in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "veterans-park-close-by-charlotte-28213-apartments",
      "search_query": "Veterans Park close by Charlotte 28213 apartments",
      "category": "Park",
      "h1_title": "Charlotte 28213 Apartments Near Veterans Park",
      "h2_subtitle": "Explore Newell Village, offering Charlotte 28213 apartments conveniently located near Veterans Park, combining comfort with accessibility.",
      "page_copy": "Welcome to Newell Village, where our Charlotte 28213 apartments are ideally positioned just a short distance from Veterans Park. This prime location in Newell South offers residents the perfect balance between city amenities and opportunities for outdoor recreation.\n\nInside Newell Village, you will find thoughtfully designed spaces featuring spacious closets, stainless steel appliances, and luxury flooring. With amenities like a security deposit alternative and comprehensive lawn maintenance, we strive to make life easier for our residents. Enjoy being part of a welcoming community that places you minutes away from the vibrant heart of Charlotte, while also giving you convenient access to the natural beauty of Veterans Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Charlotte 28213 Apartments Near Veterans Park",
      "seo_description": "Find your new home at Newell Village, offering apartments near Veterans Park in Charlotte, NC, with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-near-unc-charlotte-main-station",
      "search_query": "apartments near UNC Charlotte Main Station",
      "category": "Transit",
      "h1_title": "Apartments Near UNC Charlotte Main Station",
      "h2_subtitle": "Discover Newell Village, offering ideal apartments near UNC Charlotte Main Station, perfect for students and faculty alike.",
      "page_copy": "Welcome to Newell Village, your destination for apartments near UNC Charlotte Main Station. Our community, located in the vibrant Newell South area, offers convenient access to the university's main campus, making it an excellent choice for students and faculty seeking proximity and comfort.\n\nAt Newell Village, you'll enjoy contemporary living with features like stainless steel appliances, spacious closets, and upscale flooring. We provide a security deposit alternative and handle lawn maintenance, ensuring a stress-free living experience. Immerse yourself in a dynamic community that provides the perfect blend of academic convenience and modern amenities, all just moments away from UNC Charlotte.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UNC Charlotte Main Station",
      "seo_description": "Find modern living at Newell Village, offering apartments close to UNC Charlotte Main Station with convenient amenities and a prime location in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "rentals-close-old-concord-road-station-charlotte",
      "search_query": "rentals close to Old Concord Road Station Charlotte NC",
      "category": "Transit",
      "h1_title": "Rentals Near Old Concord Road Station, Charlotte",
      "h2_subtitle": "Explore Newell Village, offering rentals near Old Concord Road Station in Charlotte, NC, blending modern comfort with prime location advantages.",
      "page_copy": "Welcome to Newell Village, where you can find exceptional rentals conveniently located close to Old Concord Road Station in Charlotte, NC. Our community is nestled in the Newell South neighborhood, providing easy access to public transportation for effortless commuting throughout the city.\n\nNewell Village offers a range of amenities, including stainless steel appliances, spacious closets, and luxury flooring, designed to enhance your living experience. Our community also features a security deposit alternative and professional lawn maintenance services. Relish in the convenience of being near Old Concord Road Station while enjoying the stylish comforts and amenities of Newell Village, right here in Charlotte.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Old Concord Road Station, Charlotte",
      "seo_description": "Discover Newell Village rentals near Old Concord Road Station in Charlotte, NC, offering modern amenities and easy access to transit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "apartments-by-university-city-blvd-28213",
      "search_query": "apartments by University City Blvd 28213",
      "category": "Transit",
      "h1_title": "Apartments by University City Blvd 28213",
      "h2_subtitle": "Discover Newell Village, where you’ll find fantastic apartments by University City Blvd in the 28213 area, perfect for vibrant urban living.",
      "page_copy": "Welcome to Newell Village, offering premium apartments conveniently located by University City Blvd in the bustling 28213 area. Nestled in the vibrant Newell South neighborhood, our community provides residents with swift access to a variety of dining, shopping, and entertainment options.\n\nExperience the superior lifestyle at Newell Village, where stainless steel appliances, spacious closets, and luxury flooring adorn every apartment. Additionally, our security deposit alternative and comprehensive lawn maintenance service make life easier. Embrace a dynamic urban lifestyle with the comforts of modern amenities while enjoying the proximity to University City Blvd’s vibrant community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by University City Blvd 28213",
      "seo_description": "Find your home at Newell Village, with apartments by University City Blvd in 28213, offering modern amenities in a convenient Charlotte location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "newell-south-apartments-sugar-creek-station",
      "search_query": "Newell South apartments by Sugar Creek Station",
      "category": "Transit",
      "h1_title": "Newell South Apartments by Sugar Creek Station",
      "h2_subtitle": "Welcome to Newell Village, your destination for top-tier Newell South apartments near Sugar Creek Station, offering convenience and style.",
      "page_copy": "Discover Newell Village, a premier choice for Newell South apartments located by Sugar Creek Station. Our community presents an ideal living experience, featuring both convenience and modern amenities in a vibrant neighborhood setting in Charlotte, NC.\n\nAt Newell Village, residents enjoy stainless steel appliances, expansive closets, and attractive luxury flooring. We also provide a security deposit alternative and meticulous lawn maintenance, ensuring a comfortable and hassle-free lifestyle. Enjoy the proximity to Sugar Creek Station, enhancing your commute and accessibility while living in the welcoming surroundings of Newell Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Newell South Apartments by Sugar Creek Station",
      "seo_description": "Explore Newell Village for Newell South apartments near Sugar Creek Station, blending convenience and modern amenities in Charlotte.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167641",
      "source": "generator",
      "page_item_url": "mecklenburg-county-apartments-parkwood-transportation",
      "search_query": "Mecklenburg County apartments near Parkwood Transportation",
      "category": "Transit",
      "h1_title": "Mecklenburg County Apartments Near Parkwood Transportation",
      "h2_subtitle": "Find your perfect home at Newell Village, offering Mecklenburg County apartments near Parkwood Transportation, ensuring seamless connectivity.",
      "page_copy": "Welcome to Newell Village, a top choice for those seeking apartments in Mecklenburg County near Parkwood Transportation. Our community offers easy access to public transit, making it a breeze to navigate Charlotte and beyond.\n\nNewell Village apartments come equipped with desirable features such as stainless steel appliances, spacious closets, and elegant luxury flooring. With an innovative security deposit alternative and thorough lawn maintenance services, living here is hassle-free. Enjoy the combination of modern amenities and prime location that Newell Village provides, all within the vibrant surroundings of Mecklenburg County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mecklenburg County Apartments Near Parkwood Transportation",
      "seo_description": "Discover Newell Village, offering Mecklenburg County apartments near Parkwood Transportation with modern amenities and excellent connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977245716"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PS544WDZ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57148496392"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/9zw47646w87"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/f2459f77-d479-4836-b8a8-3202e2c99742/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f5764312-ff93-11ef-9460-b358d0032fa0"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "855-951-2629"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "866-828-0813"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977245716",
  "custom_google_gtm_id": "GTM-PS544WDZ",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57148496392",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/9zw47646w87",
  "custom_self_guided_tour_url": "https://selftournow.com/property/f2459f77-d479-4836-b8a8-3202e2c99742/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f5764312-ff93-11ef-9460-b358d0032fa0",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "855-951-2629",
  "custom_paid_social_tracking_phone_number": "866-828-0813",
  "custom_audioeye_site_id": "f7e790f1-3f04-47b6-9ef3-f44ab371ef4f",
  "custom_audioeye_site_hash": "1f644c83993c70ddd268df6ca5f540f9"
};

export const generatedAt = '2026-10-29T18:33:29.996Z';
